import { Injectable } from '@angular/core';
import { TrinityService } from '../trinity/trinity.service';
import { FileProperty, Property, PropertyFeedback } from 'app/types';

@Injectable({
  providedIn: 'root',
})
export class CustomLabelService {
  private readonly endpoint: string = '/custom-property';

  constructor(private trinityService: TrinityService) {}

  getProperties() {
    return this.trinityService.get<Property[]>(`/properties`, {
      authorized: true,
    });
  }

  getFileProperties(fileId: string) {
    return this.trinityService.get<FileProperty[]>(
      `/properties/assignments/files/${fileId}`,
      {
        authorized: true,
      },
    );
  }

  getSuggestedProperties(fileId: string) {
    return this.trinityService.get<Property[]>(
      `/properties/assignments/suggestions/files/${fileId}`,
      {
        params: { feedback: 'null' },
        authorized: true,
      },
    );
  }

  rejectFileProperty(data: PropertyFeedback) {
    return this.trinityService.post(
      `/properties/assignments/suggestions/feedback`,
      {
        authorized: true,
        body: data,
      },
    );
  }

  acceptFileProperties(data: PropertyFeedback[]) {
    return this.trinityService.post(
      `/properties/assignments/suggestions/feedback/bulk`,
      {
        body: data,
        authorized: true,
      },
    );
  }

  updateFileProperties(fileId: string, data: FileProperty[]) {
    return this.trinityService.put<FileProperty[]>(
      `/properties/assignments/files/${fileId}`,
      {
        body: data,
        authorized: true,
      },
    );
  }
}
